import { apiBillPayment } from '@api/apiCall';
import ShimmerBPList from '@atoms/Shimmers/ShimmerBPList';
import { useToast } from '@hooks';
import { useIsFocused, useNavigation } from '@react-navigation/native';
import appStyles from '@root/appStyles';
import { getStore } from '@store/storeUtils';
import { useMutation } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshControl, ScrollView } from 'react-native';
import { shouldRenderError, shouldSetBPListOnSuccess, shouldShowProductCategoryList } from './bpListUtils';

interface BPListProps {
  source?: string;
}

interface BPProduct {
  id: string;
  name: string;
}

const BPList: React.FC<BPListProps> = ({ source = '' }) => {
  const [bpProducts, setBPProducts] = useState<BPProduct[]>([]);
  const { selectedBPAccount, setInitialData } = getStore();
  const toast = useToast();
  const { t } = useTranslation('common');
  const navigation = useNavigation();

  const isFocused = useIsFocused();

  const {
    isLoading,
    mutate: fetchBP,
    isSuccess,
    data,
    isError,
    error,
  } = useMutation({
    mutationFn: (payload: any) => apiBillPayment(payload),
  });

  useEffect(() => {
    if (isFocused) fetchBP(selectedBPAccount);
  }, [selectedBPAccount, isFocused]);

  useEffect(() => {
    shouldRenderError(isError, error, toast, t, navigation, setInitialData);
  }, [isError, error, toast, t, navigation, setInitialData]);

  useEffect(() => {
    shouldSetBPListOnSuccess(isSuccess, data, setBPProducts);
  }, [isSuccess, data]);

  return (
    <ScrollView
      style={[appStyles.marginTop(16), appStyles.safeAreaView]}
      refreshControl={<RefreshControl refreshing={isLoading} onRefresh={() => fetchBP(selectedBPAccount)} />}>
      {isLoading ? <ShimmerBPList /> : shouldShowProductCategoryList(bpProducts, source)}
    </ScrollView>
  );
};

export default BPList;
